import { render, staticRenderFns } from "./ToeflJuniorTimeManagerComponent.vue?vue&type=template&id=36d3ffe1&scoped=true&"
import script from "./ToeflJuniorTimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflJuniorTimeManagerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflJuniorTimeManagerComponent.vue?vue&type=style&index=0&id=36d3ffe1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3ffe1",
  null
  
)

export default component.exports